import { render, staticRenderFns } from "./StatisticsPane.vue?vue&type=template&id=5165f3f2"
import script from "./StatisticsPane.vue?vue&type=script&lang=js"
export * from "./StatisticsPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports